/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Escrow
 */
export interface Escrow {
    /**
     * The amount of tokens that are delegated to this validator account, and are NOT in the process of debonding.
     * @type {string}
     * @memberof Escrow
     */
    active_balance?: string;
    /**
     * The shares of tokens that are delegated to this validator account, and are NOT in the process of debonding.
     * @type {string}
     * @memberof Escrow
     */
    active_shares?: string;
    /**
     * The amount of tokens that are delegated to this validator account, but are also in the process of debonding (i.e. they will be unstaked within ~2 weeks).
     * @type {string}
     * @memberof Escrow
     */
    debonding_balance?: string;
    /**
     * The shares of tokens that are delegated to this validator account, but are also in the process of debonding (i.e. they will be unstaked within ~2 weeks).
     * @type {string}
     * @memberof Escrow
     */
    debonding_shares?: string;
    /**
     * The amount of token this validator has delegated to itself, and are NOT in the process of debonding.
     * @type {string}
     * @memberof Escrow
     */
    self_delegation_balance?: string;
    /**
     * The shares of tokens this validator has delegated to itself, and are NOT in the process of debonding.
     * @type {string}
     * @memberof Escrow
     */
    self_delegation_shares?: string;
    /**
     * The active_balance of this validator account 24 hours ago.
     * @type {string}
     * @memberof Escrow
     */
    active_balance_24?: string;
    /**
     * The number of accounts that have delegated token to this account.
     * @type {number}
     * @memberof Escrow
     */
    num_delegators?: number;
}

export function EscrowFromJSON(json: any): Escrow {
    return EscrowFromJSONTyped(json, false);
}

export function EscrowFromJSONTyped(json: any, ignoreDiscriminator: boolean): Escrow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active_balance': !exists(json, 'active_balance') ? undefined : json['active_balance'],
        'active_shares': !exists(json, 'active_shares') ? undefined : json['active_shares'],
        'debonding_balance': !exists(json, 'debonding_balance') ? undefined : json['debonding_balance'],
        'debonding_shares': !exists(json, 'debonding_shares') ? undefined : json['debonding_shares'],
        'self_delegation_balance': !exists(json, 'self_delegation_balance') ? undefined : json['self_delegation_balance'],
        'self_delegation_shares': !exists(json, 'self_delegation_shares') ? undefined : json['self_delegation_shares'],
        'active_balance_24': !exists(json, 'active_balance_24') ? undefined : json['active_balance_24'],
        'num_delegators': !exists(json, 'num_delegators') ? undefined : json['num_delegators'],
    };
}

export function EscrowToJSON(value?: Escrow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active_balance': value.active_balance,
        'active_shares': value.active_shares,
        'debonding_balance': value.debonding_balance,
        'debonding_shares': value.debonding_shares,
        'self_delegation_balance': value.self_delegation_balance,
        'self_delegation_shares': value.self_delegation_shares,
        'active_balance_24': value.active_balance_24,
        'num_delegators': value.num_delegators,
    };
}


